import { memo, useRef, useState, Fragment } from 'react';
import { useTranslations } from 'next-intl';
import {
  Popover,
  PopoverPanel,
  PopoverButton,
  Transition,
} from '@headlessui/react';
import { Link } from '@/i18n/routing';
import { ChevronDownIcon } from '@/component/Icons/ChevronDownIcon';

export const PopoverMenuComponent = ({ menuItem, children }) => {
  const t = useTranslations();
  const [isHover, setIsHover] = useState(false);
  const ref = useRef(null);

  return (
    <Popover
      ref={ref}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="relative"
    >
      <PopoverButton className="inline-flex items-center gap-x-1 text-base text-slate-500 hover:text-slate-700 focus:#197775 outline-none">
        {menuItem.href ? (
          <Link href={menuItem.href} prefetch={false}>
            {t(menuItem.title || menuItem.name)}
          </Link>
        ) : (
          <span>{t(menuItem.title || menuItem.name)}</span>
        )}
        <ChevronDownIcon className="h-6 w-6" aria-hidden="true" />
      </PopoverButton>

      <Transition
        show={isHover}
        static
        as={Fragment}
        enter="transition ease-out duration-300"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel className="absolute left-0 pt-3 z-10 -mt-1 flex w-screen max-w-max">
          {children({ close: () => setIsHover(false) })}
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export const PopoverMenu = memo(
  PopoverMenuComponent,
  (prevProps, props) =>
    !!prevProps.destinations && prevProps.menuItem.name === props.menuItem.name,
);
